import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=49dc6028"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=49dc6028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports